export const attendance = [
  {
    path: '/attendance/daily',
    component: () => import('@/attendance_v3/AttendancePage.vue')
  }
]

